module.exports = __webpack_public_path__ + "static/media/dog_tempPlacement.45dc2177.png";